<!-- Avatar icon button that triggers the menu -->
<button
    mat-icon-button
    [matMenuTriggerFor]="userActions"
    class="relative"
>
    <span class="relative">
        <!-- Avatar con imagen -->
        <img
            class="w-7 h-7 max-w-7 max-h-7 rounded-full object-cover"
            *ngIf="showAvatar && user?.imageURL"
            [src]="user.imageURL"
            alt="User avatar"
            referrerpolicy="no-referrer"
        />

        <!-- Fallback: inicial dentro de círculo gris -->
        <div
            *ngIf="!showAvatar || !user?.imageURL"
            class="w-7 h-7 rounded-full bg-gray-200 text-gray-900 flex items-center justify-center text-lg font-extrabold uppercase select-none"
            aria-hidden="true"
        >
            {{ userInitial }}
        </div>

        <!-- Status dot -->
        <span
            class="absolute right-0 bottom-0 w-2 h-2 rounded-full"
            [ngClass]="{
                'mr-px mb-px': !showAvatar || !user?.imageURL,
                'bg-green-500': user?.status === 'online',
                'bg-amber-500': user?.status === 'away',
                'bg-red-500': user?.status === 'busy',
                'bg-gray-400': user?.status === 'not-visible'
            }"
        ></span>
    </span>
</button>

<mat-menu
    [xPosition]="'before'"
    #userActions="matMenu">

    <!-- Logged-in as widget, we have to force no opacity and regular text on mat-menu-item -->
    <button mat-menu-item disabled class="opacity-100">
        <span class="flex flex-col leading-none">
            <span class="text-default">{{ 'Signed in as' | transloco }}</span>
            <span class="mt-2 text-md font-medium text-default">{{user.email}}</span>
        </span>
    </button>

    <button mat-menu-item disabled class="opacity-100">
        <span class="flex flex-col leading-none w-full">
            <app-profile-progress-bar [activateTooltip]="false"></app-profile-progress-bar>
        </span>
    </button>

    <mat-divider class="my-2"></mat-divider>

    <!-- Change company menu-item -->
    <button mat-menu-item (click)="openChangeCompany()" [disabled]="!changeCompanyEnabled()" [class.opacity-100]="!changeCompanyEnabled()">
        <span class="flex flex-col leading-none">
            <span class="flex flex-row leading-none justify-between items-baseline">
                @if (user?.companies.length > 0) {
                    <span class="text-default mr-3">{{ 'In company' | transloco }}</span>
                    <button *ngIf="user?.companies?.length > 1"
                            class="h-5 min-h-4 min-w-10 px-2 py-2 rounded-full bg-hover"
                            mat-button>
                        <span class="font-medium text-sm text-secondary">{{ 'Change' | transloco }}</span>
                    </button>
                } @else {
                    <span class="text-default mr-3">{{ 'Not yet in a company' | transloco }}</span>
                    <button
                            routerLink="/link-company"
                            class="h-5 min-h-4 min-w-10 px-2 py-2 rounded-full bg-hover"
                            mat-button>
                        <span class="font-medium text-sm text-secondary">{{ 'Link' | transloco }}</span>
                    </button>
                }
            </span>
            <span *ngIf="user?.companies?.length > 0" class="mt-2 text-md font-medium text-default">{{companyName || "N/A"}}</span>
        </span>
    </button>

    <mat-divider class="my-2"></mat-divider>

    <languages></languages>

    <mat-divider class="my-2"></mat-divider>

    <!-- TODO Re-enable when defined, or remove if profile will never be implemented.
    <button mat-menu-item>
        <mat-icon [svgIcon]="'heroicons_outline:user-circle'"></mat-icon>
        <span>{{ 'Profile' | transloco }}</span>
    </button>
    -->

    <button mat-menu-item [routerLink]="['/settings/account']">
        <mat-icon [svgIcon]="'heroicons_outline:cog-8-tooth'"></mat-icon>
        <span>{{ 'Settings' | transloco }}</span>
    </button>
    <!--
    <button
        mat-menu-item
        [matMenuTriggerFor]="userStatus">
        <mat-icon [svgIcon]="'heroicons_outline:ellipsis-horizontal-circle'"></mat-icon>
        <span>Status</span>
    </button>
    -->
    <mat-divider class="my-2"></mat-divider>
    <button
        mat-menu-item
        (click)="goToHelpCenter()">
        <mat-icon [svgIcon]="'heroicons_outline:question-mark-circle'"></mat-icon>
        <span>{{ 'Help center' | transloco }}</span>
    </button>
    <button
        mat-menu-item
        (click)="goToPrivacyPolicy()"
        >
        <mat-icon [svgIcon]="'mat_symbols_outlined:contract_edit'"></mat-icon>
        <span>{{ 'Privacy policy' | transloco }}</span>
    </button>
    <button
        mat-menu-item
        (click)="goToTermsAndConditions()">
        <mat-icon [svgIcon]="'mat_outline:contact_page'"></mat-icon>
        <span>{{ 'Terms and Conditions' | transloco }}</span>
    </button>
    <mat-divider class="my-2"></mat-divider>
    <button
        mat-menu-item
        (click)="signOut()">
        <mat-icon [svgIcon]="'heroicons_outline:arrow-right-on-rectangle'"></mat-icon>
        <span>{{ 'Sign out' | transloco }}</span>
    </button>
</mat-menu>
